/* eslint-disable react/prop-types */
import uniqId from 'uniqid';
import cx from 'classnames';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import GalleryButton from '../../../common/gallery/GalleryButton';
import './inspirationalImages.scss';

const InspirationalImage = ({
  className,
  image,
  children,
  isLarge,
  single,
  index,
  isConceptHotel,
  isGlobe,
}) => {
  const { caption } = image;
  const fullWidth = isLarge && (single || isConceptHotel || isGlobe);
  const fullWidthMobile = isConceptHotel && index === 0;

  let sizes;
  switch (true) {
    case fullWidth:
      sizes = [
        {
          width: 1280,
          height: 510,
          breakpoint: 975,
        },
        {
          width: 925,
          height: 370,
          breakpoint: 768,
        },
        { width: 768, height: 300, breakpoint: 416 },
        { width: 415, height: isGlobe ? 240 : 350 },
      ];
      break;
    case isLarge:
      sizes = [
        {
          width: 800,
          height: 510,
          breakpoint: 975,
        },
        {
          width: 625,
          height: 370,
          breakpoint: 768,
        },
        { width: 768, height: 300, breakpoint: 416 },
        { width: 415, height: 350 },
      ];
      break;
    case isGlobe:
      sizes = [
        {
          width: 610,
          height: 420,
          breakpoint: 975,
        },
        { width: 450, height: 300, breakpoint: 768 },
        {
          width: 360,
          height: 225,
          breakpoint: 456,
        },
        {
          width: 200,
          height: 125,
        },
      ];
      break;
    default:
      sizes = [
        {
          width: 384,
          height: isConceptHotel ? 290 : 240,
          breakpoint: 975,
        },
        { width: 305, height: 175, breakpoint: 768 },
        {
          width: fullWidthMobile ? 768 : 365,
          height: fullWidthMobile ? 200 : 222,
          breakpoint: 416,
        },
        {
          width: fullWidthMobile ? 415 : 200,
          height: fullWidthMobile ? 200 : 120,
        },
      ];
  }

  return (
    <div className={className}>
      <CloudinaryPicture img={image} sizes={sizes} alt={caption} />
      {children}
    </div>
  );
};

const InspirationalImages = ({
  images,
  labels,
  openGallery,
  isConceptHotel,
  isGlobe,
}) => {
  if (!images?.length) return null;
  const smallImagesCount = isConceptHotel && !isGlobe ? 3 : 2;
  const smallImages = images.slice(1, 1 + smallImagesCount);
  const smallImgLength = smallImages.length;

  const singleImageLayout = smallImgLength === 0;
  const doubleImageLayout = smallImgLength === 1;

  return (
    <div
      className={cx('gw-hotel-inspirational-images', {
        'gw-hotel-inspirational-images--globe': isGlobe,
        'gw-hotel-inspirational-images--single': singleImageLayout,
        'gw-hotel-inspirational-images--double': doubleImageLayout,
      })}
    >
      <InspirationalImage
        isConceptHotel={isConceptHotel}
        isGlobe={isGlobe}
        image={images[0]}
        className="gw-hotel-inspirational-images__large"
        isLarge
        single={singleImageLayout}
      >
        <GalleryButton
          className="gw-hotel-inspirational-images__gallery-button"
          onClick={() => openGallery()}
          text={labels}
        />
      </InspirationalImage>
      {smallImages.map((image, index) => {
        return (
          <InspirationalImage
            isConceptHotel={isConceptHotel}
            isGlobe={isGlobe}
            index={index}
            key={uniqId('small-image')}
            image={image}
            className={`gw-hotel-inspirational-images__small gw-hotel-inspirational-images__small--${
              index + 1
            }`}
            isLarge={doubleImageLayout}
          />
        );
      })}
    </div>
  );
};

export default InspirationalImages;
